export const USER_ROLE_VALUES = ["user", "admin"];
export const UserRole = {
    USER: "user",
    ADMIN: "admin",
};
export const USER_ROLE_LABELS = {
    [UserRole.USER]: "Member",
    [UserRole.ADMIN]: "Admin",
};
